<style src="@/assets/css/common_parts_input.css" type="text/css" media="all" scoped></style>
<style src="@/assets/css/common_parts_course.css" type="text/css" media="all" scoped></style>
<style src="@/assets/css/common_parts_price.css" type="text/css" media="all" scoped></style>

<style scoped>
  /* 検査項目の背景色
     getBackendColorInspectionJskbで
     受診区分(1:全員 2:一部)を判定
  */
  .courseListKensa0 {}
  .courseListKensa1 {}

</style>
<template>
  <div class="container" id="step01">
    <div class="contents">
    <h2>健診予約</h2>
      <section class="flow">
        <h3>予約申し込みの流れ</h3>
        <ol>
          <li>コース選択</li>
          <li>オプション選択</li>
          <li>受診日時選択</li>
          <li>予約情報入力</li>
          <li>予約情報確認</li>
          <li>予約確定</li>
        </ol>
      </section>
      <!-- ▽  -->
      <section id="mainContents">
        <section class="inputArea">
          <h3>【受診コース選択】</h3>
          <p>受診コースを選択してください。</p>
          <!-- 受診コースない場合に表示する -->
          <div class="listMessage">
            <ul v-if="inputForm.listCourse.length == 0">
              <li v-for="item in inputForm.ermsList" v-bind:key="item">{{item}}</li>
            </ul>
          </div>
          <article class="course" v-for="course in inputForm.listCourse" v-bind:key="course.kscd">
            <h4>{{course.ksnm}}</h4>
            <p class="time"><span>所要時間</span>{{course.time}}</p>
            <dl class="item">
              <dt>検査項目</dt>
              <dd>
                <ul><li v-for="inspection in course.listInspection" v-bind:key="inspection.kmnm" v-bind:class="getBackendColorInspectionJskb(inspection.jskb)">{{inspection.kmnm}}</li></ul>
              </dd>
            </dl>
            <div class="note">
              <div class="listMessage">
                <ul>
                  <li v-for="item in course.mem1List" v-bind:key="item">
                    {{item}}
                  </li>
                </ul>
              </div>
              <div class="price">
                <p class="base">基本料金
                  <b>
                    <template v-if="inputForm.kshj=='1'">
                      {{course.gkgk | moneyDelimiter}}
                      <span v-if="inputForm.taxk=='1'">（税抜）</span>
                      <span v-else>（税込）</span>
                    </template>
                  </b>
                </p>
                <div class="btnLst"><button class="nextBtn" v-on:click="onChoiceCourse(course.kscd,course.jkcd)">選択</button></div>
              </div>
            </div>
            <dl class="target">
              <dt>この検査を受けて欲しい方</dt>
              <dd>
                <ul>
                  <li v-for="item in course.mem2List" v-bind:key="item">
                    {{item}}
                  </li>
                </ul>
              </dd>
            </dl>
          </article>
        </section>
        <div class="btnLst">
        	<button class="backBtn" v-on:click="onBack">戻る</button>
        </div>
      </section>
      <!-- モーダルWindow S -->
      <modalWindow v-show="modal.validationError.isShow" v-on:close="onValidationErrorModalClose">
        <dt slot="modal-header">入力エラー</dt>
        <dd slot="modal-body">
          <errorMessageBox :errorMessages="modal.validationError.messages"></errorMessageBox>
        </dd>
        <dd slot="modal-footer"><a href="javascript:void(0)" v-on:click="onValidationErrorModalClose">閉じる</a></dd>
      </modalWindow>
      <!-- モーダルWindow E -->
      <!-- モーダルWindow S -->
      <modalWindow v-show="modal.systemError.isShow" v-on:close="onSystemErrorModalClose">
        <dt slot="modal-header">システムエラー</dt>
        <dd slot="modal-body">
          <errorMessageBox :errorMessages="modal.systemError.messages"></errorMessageBox>
        </dd>
        <dd slot="modal-footer"><a href="javascript:void(0)" v-on:click="onSystemErrorModalClose">閉じる</a></dd>
      </modalWindow>
      <!-- モーダルWindow E -->
    </div>
  </div>
</template>
<script>
  import { CommonSelectCourse } from '@/api'
  import * as types from '@/store/mutation-types'
  import * as ErrorCodes from '@/components/Utility/error-codes'
  import ErrorMessageBox from '@/components/Utility/ErrorMessageBox'
  import ModalWindow from '@/components/Utility/ModalWindow'
  import * as UtilityConsoleLog from '@/components/Utility/UtilityConsoleLog'

  export default {
    // モジュール名
    name: 'CommonSelectCourse',
    // 使用コンポーネント
    components: {
      // エラー表示コンポーネント
      errorMessageBox: ErrorMessageBox,
      // モーダルウィンドウ表示コンポーネント
      modalWindow: ModalWindow
    },
    // データ
    data() {
      return {

        // ユーザータイプ
        userType: '0',
        // 0: マイページ経由かつ新規予約（個人）
        codeUserTypeMyPageNewIndividual: '0',
        // 1: マイページ経由かつ新規予約（健保）
        codeUserTypeMyPageNewHealth: '1',
        // 2: マイページ経由かつ予約変更（個人）
        codeUserTypeMyPageChangeIndividual: '2',
        // 3: マイページ経由かつ予約変更（健保）
        codeUserTypeMyPageChangeHealth: '3',
        // 4: ゲストログインかつ新規予約（個人）
        codeUserTypeGuestNewIndividual: '4',
        // 5: ゲストログインかつ新規予約（健保）
        codeUserTypeGuestNewHealth: '5',
        // 6: 途中ログインかつ新規予約（個人）
        codeUserTypeEnRouteNewIndividual: '6',
        // 7: 途中ログインかつ新規予約（健保）
        codeUserTypeEnRouteNewHealth: '7',

        inputForm: {
          // 消費税区分
          // 1: 外税 税抜
          // 2: 内税 税込
          taxk: '0',

          // 金額表示
          // 0:非表示 1:表示
          kshj: '0',

          // 受診コースない場合の文章
          ermsList: [],

          // コース一覧表示用のリスト
          // key コースキー
          // ksnm コース名称
          // time 所要時間
          // mem1 コース説明
          // mem2 お勧め
          // kngk 本体価格
          // gkgk 消費税考慮済み金額
          // listInspection 検査項目リスト
          //  kmnm 検査項目名称
          //  jskb 受診区分(1:全員 2:一部)
          listCourse: [],
        },

        // モーダルウィンドウ
        modal: {
          validationError: {
            messages: [],
            isShow: false
          },
          systemError: {
            messages: [
							'システムエラーです。',
							'内容をもう一度ご確認ください。'
						],
            isShow: false
          }
        }
      }
    },
    // フィルター
    filters: {
      // 金額表示用三桁ごとにカンマをつける
      moneyDelimiter: function(value) {

        if(value == null) {
          return ''
        }
        
        return value.toLocaleString()
      }
    },
    // ライフサイクルフック: created
    created: function () {
      UtilityConsoleLog.consoleLog('CommonSelectCourse::created Start')

      this.firstDisplay()

      UtilityConsoleLog.consoleLog('CommonSelectCourse::created End')
    },
    methods: {
      // 表示系--------------------------------------------------S
      // 初期表示
      firstDisplay: function () {
        UtilityConsoleLog.consoleLog('CommonSelectCourse::firstDisplay Start')

        // 金額表示、消費税区分、コース一覧を取得
        CommonSelectCourse.FirstDisplay({
          ircd: this.$store.state.auth.ircd,
          jgcd: this.$store.state.commonUserInfo.newHealthInsurance.jgcd,
          nend: this.$store.state.commonUserInfo.newHealthInsurance.nend,
          hfkb: this.$store.state.commonUserInfo.newHealthInsurance.hfkb,
          sex: this.$store.state.commonUserInfo.newHealthInsurance.sex,
          age: this.$store.state.commonUserInfo.newHealthInsurance.age
        }).then(({ responce }) => {
          if (responce.data.errorCode == ErrorCodes.ERRORCODE_DEFAULT) {

            this.inputForm.kshj = responce.data.kshj
            this.inputForm.taxk = responce.data.taxk
            this.inputForm.ermsList = responce.data.ermsList
            this.inputForm.listCourse = responce.data.listCourse

          } else if (responce.data.errorCode == ErrorCodes.ERRORCODE_SIMPLEITEM
            || responce.data.errorCode == ErrorCodes.ERRORCODE_SYSTEM
            || responce.data.errorCode == ErrorCodes.ERRORCODE_DB) {
            this.onSystemErrorModalOpen()
          }
        }).catch(() => {
          this.onSystemErrorModalOpen()
        }).finally(() => {
	        UtilityConsoleLog.consoleLog('CommonSelectCourse::firstDisplay End')
	      })

      },
      // 表示系--------------------------------------------------E
      // イベント系--------------------------------------------------S
      // コース選択ボタン押下時
      onChoiceCourse: function (in_kscd,in_jkcd) {

        UtilityConsoleLog.consoleLog('CommonSelectCourse::onChoiceCourse Start')

        // コースコードをストアに保存
        this.$store.commit(
          types.COMMON_SELECTCOURSE,
          {
            kscd: in_kscd,
            jkcd: in_jkcd
          }
        )

        // オプション選択画面へ遷移
        this.$router.push("/CommonSelectOption")

        UtilityConsoleLog.consoleLog('CommonSelectCourse::onChoiceCourse End')
      },
      // 戻るボタン押下時
      onBack: function () {
        UtilityConsoleLog.consoleLog('CommonSelectCourse::onBack Start')

        // ユーザータイプ毎にストア値のリセットするミューテーションと
        // 戻り遷移先を変更する
        var tempUserType = this.getUserType()

        // ユーザー
        if(this.codeUserTypeMyPageNewIndividual == tempUserType) {
          // 0: マイページ経由かつ新規予約（個人）

          // ストアの値をリセット
          this.$store.commit(
            types.COMMON_SELECTCOURSE_BACK_USERTYPE0)

          // マイページ画面へ遷移
          this.$router.push("/CommonMyPage")

        } else if(this.codeUserTypeMyPageNewHealth == tempUserType) {
          // 1: マイページ経由かつ新規予約（健保）

          // ストアの値をリセット
          this.$store.commit(
            types.COMMON_SELECTCOURSE_BACK_USERTYPE1)

          // 新規健保予約画面へ遷移
          this.$router.push("/CommonNewHealthInsurance")

        } else if(this.codeUserTypeMyPageChangeIndividual == tempUserType) {
          // 2: マイページ経由かつ予約変更（個人）

          // ストアの値をリセット
          this.$store.commit(
            types.COMMON_SELECTCOURSE_BACK_USERTYPE2)

          // マイページ画面へ遷移
          this.$router.push("/CommonMyPage")

        } else if(this.codeUserTypeMyPageChangeHealth == tempUserType) {
          // 3: マイページ経由かつ予約変更（健保）

          // ストアの値をリセット
          this.$store.commit(
            types.COMMON_SELECTCOURSE_BACK_USERTYPE3)

          // マイページ画面へ遷移
          this.$router.push("/CommonMyPage")

        } else if(this.codeUserTypeGuestNewIndividual == tempUserType) {
          // 4: ゲストログインかつ新規予約（個人）

          // ストアの値をリセット
          this.$store.commit(
            types.COMMON_SELECTCOURSE_BACK_USERTYPE4)
				  // URLパラム
				  var tempParam = this.$store.getters.getCommonParam
          // トップ画面へ遷移
          this.$router.push('/CommonTop/' + tempParam)

        } else if(this.codeUserTypeGuestNewHealth == tempUserType) {
          // 5: ゲストログインかつ新規予約（健保）

          // ストアの値をリセット
          this.$store.commit(
            types.COMMON_SELECTCOURSE_BACK_USERTYPE5)

          // 新規健保予約画面へ遷移
          this.$router.push("/CommonNewHealthInsurance")

        } /*else if(this.codeUserTypeEnRouteNewIndividual == tempUserType) {
          // 6: 途中ログインかつ新規予約（個人）

          // ストアの値をリセット
          //this.$store.commit(
          //  types.COMMON_SELECTCOURSE_BACK_USERTYPE6)

          // :TODO 途中ログイン画面へ遷移
          //this.$router.push("/")

        } else if(this.codeUserTypeEnRouteNewHealth == tempUserType) {
          // 7: 途中ログインかつ新規予約（健保）

          // ストアの値をリセット
          //this.$store.commit(
          //  types.COMMON_SELECTCOURSE_BACK_USERTYPE7)

          // :TODO 途中ログイン画面へ遷移
          //this.$router.push("/")
        }*/

        UtilityConsoleLog.consoleLog('CommonSelectCourse::onBack End')
      },
      // イベント系--------------------------------------------------E
      // その他--------------------------------------------------S
      // ストア値などからユーザータイプを取得
      getUserType: function(){
      
        UtilityConsoleLog.consoleLog('CommonSelectCourse::getUserType Start')

      	var resultUserType = ''

      	// マイページ経由、ゲストログイン、途中ログインかどうか
      	if(this.$store.state.commonUserInfo.myPage.isUse) {
      	  // マイページ経由

      	  // 新規予約か予約変更どうか
      	  if(this.$store.state.commonUserInfo.myPage.choiceUkno == '') {
      	    // 新規予約

      	    // 個人か健保かどうか
      	    if(!this.$store.state.commonUserInfo.newHealthInsurance.isUse){
      	      // 個人
      	      resultUserType = this.codeUserTypeMyPageNewIndividual
      	    } else {
      	      // 健保
      	      resultUserType = this.codeUserTypeMyPageNewHealth
      	    }
      	  } else {
      	    // 予約変更

      	    // 個人か健保かどうか
      	    if('00000000' == this.$store.state.commonUserInfo.newHealthInsurance.jgcd) {
      	      // 個人
      	      resultUserType = this.codeUserTypeMyPageChangeIndividual
      	    } else {
      	      // 健保
      	      resultUserType = this.codeUserTypeMyPageChangeHealth
      	    }
      	  }
      	} else if(!this.$store.state.commonUserInfo.enRouteLogin.isUse) {
      	  // 途中ログイン
      	  // 個人か健保かどうか
      	  if(!this.$store.state.commonUserInfo.newHealthInsurance.isUse){
      	    // 個人
      	    resultUserType = this.codeUserTypeGuestNewIndividual
      	  } else {
      	    // 健保
      	    resultUserType = this.codeUserTypeGuestNewHealth
      	  }
      	} else {
      	  // ゲストログイン（マイページ経由、ゲストログイン、途中ログイン）
      	  // 個人か健保かどうか
      	  if(!this.$store.state.commonUserInfo.newHealthInsurance.isUse){
            // 個人
      	    resultUserType = this.codeUserTypeEnRouteNewIndividual
      	  } else {
      	    // 健保
      	    resultUserType = this.codeUserTypeEnRouteNewHealth
      	  }
      	}

        UtilityConsoleLog.consoleLog('CommonSelectCourse::getUserType End')

      	return resultUserType
      },
      // バリデーションエラーモーダルとしてエラーモーダルを開く
      onValidationErrorModalOpen: function (messages) {

        UtilityConsoleLog.consoleLog('CommonSelectCourse::onValidationErrorModalOpen Start')

				var tempMessages = [
					'入力エラーです。',
					'以下の内容をもう一度ご確認ください'
				]
				
				errorMessages.forEach((item)=>{
					tempMessages.push(item)
				})

				this.modal.validationError.messages = tempMessages
        this.modalOpen('validationError')

        UtilityConsoleLog.consoleLog('CommonSelectCourse::onValidationErrorModalOpen End')
      },
      // バリデーションエラーモーダルを閉じる
      onValidationErrorModalClose: function () {
        UtilityConsoleLog.consoleLog('CommonSelectCourse::onValidationErrorModalClose Start')

        this.modalClose('validationError')

        UtilityConsoleLog.consoleLog('CommonSelectCourse::onValidationErrorModalClose End')
      },
      // システムエラーモーダルとしてエラーモーダルを開く
      onSystemErrorModalOpen: function () {

        UtilityConsoleLog.consoleLog('CommonSelectCourse::onSystemErrorModalOpen Start')

        this.modalOpen('systemError')

        UtilityConsoleLog.consoleLog('CommonSelectCourse::onSystemErrorModalOpen End')
      },
      // システムエラーモーダルを閉じる
      onSystemErrorModalClose: function () {
        UtilityConsoleLog.consoleLog('CommonSelectCourse::onSystemErrorModalClose Start')

        this.modalClose('systemError')

				// URLパラム
				var tempParam = this.$store.getters.getCommonParam

				// トップ画面へ遷移
				this.$router.push('/CommonTop/' + tempParam)

        UtilityConsoleLog.consoleLog('CommonSelectCourse::onSystemErrorModalClose End')
      },
      modalOpen: function (modalName) {

        UtilityConsoleLog.consoleLog('CommonSelectCourse::modalOpen Start')

				// すべてのモーダルを閉じる
				this.allModalClose()

        this.modal[modalName].isShow = true

        UtilityConsoleLog.consoleLog('CommonSelectCourse::modalOpen End')
      },
      // モーダルウィンドウを閉じる
      modalClose: function (modalName) {

        UtilityConsoleLog.consoleLog('CommonSelectCourse::modalClose Start')

        this.modal[modalName].isShow = false

        UtilityConsoleLog.consoleLog('CommonSelectCourse::modalClose End')
      },
			// 全てのモーダルを閉じる
			allModalClose: function() {  
				for(var key in this.modal) {
					this.modal[key].isShow = false
				}
			},
      // 検査項目の受診区分(1:全員 2:一部)によってCSSクラス名を返す
      // 1:全員の場合は背景色を黄色にする
      getBackendColorInspectionJskb: function (jskb) {

        var resultClassName = ''

        // 背景色を黄色にするクラス名を返す
        if ('1' == jskb) {
          resultClassName = 'courseListKensa1'
        } else {
          resultClassName = 'courseListKensa0'
        }

        return resultClassName;
      }
      // その他--------------------------------------------------E
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Common/SelectCourse/CommonSelectCourse.vue